import React from "react";

import styles from "./greeting.module.css";

const Greeting = () => {
  return (
    <section className={styles.header}>
      <article className={styles.txt}>
        <h3>제이소프트웨어와</h3>
        <h3>함께한 작업들을 확인하세요</h3>
      </article>
    </section>
  )
}

export default Greeting;